module.exports = __webpack_public_path__ + "static/media/ensenada_harinadetrigo.9ccf7226.png";